export default __webpack_public_path__ + "static/media/The Kruks Photography-1453_tn.cf044b72.jpg";